import { useBreakpoint } from '../common';

const useGetRiskColumnView = (): number => {
  const { isTabletPortrait, isDesktop } = useBreakpoint();
  if (isTabletPortrait) {
    return 1;
  }
  if (isDesktop) {
    return 3;
  }
  return 2;
};
export default useGetRiskColumnView;
